export const BASE_URL =
  // "http://192.168.1.44:8000/api/user/";
  // "https://uat-script.queenags.com/api/user/";
  // "https://Uat-user.garudaags.com/api/user/";
  // "https://Uat-backend.garudaags.com/api/user/";
  "https://backend.garudaags.com/api/user/";
  // "https://Uat-admin.garudaags.com/";


// export const WEBSOCKET_URL = "ws://192.168.1.44:9502";
// export const WEBSOCKET_URL = "wss://uat-script.queenags.com/ws/";
// export const WEBSOCKET_URL = "wss://Uat-backend.queenags.com/ws/";
export const WEBSOCKET_URL = "wss://backend.garudaags.com/ws/";

//change the app_version into the mobile app version,while release the update
export const APP_VERSION = "1.0.6";
export const URLS = {
  LOGIN: "login",
  LOGOUT: "logout",
  FORGOTPASSWORD: "forgot-password",
  VERIFYOTP: "create",
  FORGOTVERIFYOTP: "verify-otp",
  REGISTER: "register",
  CHANGEPASSWORD: "update-password",
  WALLET: "wallet/bank-details",
  QRCODE: "wallet/qrcode",
  USER: `master/by-type?version=${APP_VERSION}`,
  MASTERALL: "master/all",
  REFERRAL: "referral",
  PRICELIST: "games/price-list",
  RECHARGE: "recharge",
  SLOTLIST: "games/daily-games",
  RECHARGE: "recharge",
  WITHDRAW: "wallet/withdraw",
  NOTIFICATION: "notification",
  DAILYRESULTS: "games/report/list",
  ADDGAME: "games/cart",
  GAMECARTLIST: "games/cart",
  SUPPORTCHAT: "chat/send",
  CHATHISTORY: "chat/history",
  HOLIDAY: "today-holiday-status",
  WINNING: "games/winning/result",
  REPORTFILTER: "games/statusdatewise-game",
  REPORTLIST: "games/report",
  QGDOWNLOAD: "download-qrcode",
  UPLOAD_LOG: "upload-log",
};


export const ICON_FILTER = "brightness(0) saturate(100%) invert(8%) sepia(85%) saturate(3000%) hue-rotate(310deg) brightness(%89)";